"use client";
import Cookies from "js-cookie";
import { GrowthBook } from "@growthbook/growthbook-react";
import { v4 as uuidv4 } from "uuid";

let growthbookInstance: GrowthBook<Record<string, unknown>> | null = null;

type FeatureValue = { defaultValue: string | boolean };

const features: Record<string, FeatureValue> = {
  resp_onboarding_ca: { defaultValue: "idle" },
  resp_payment_desktop: { defaultValue: true },
  resp_payment_mobile: { defaultValue: true },
  piwik_tracking: { defaultValue: true },
};

function initGrowthbook() {
  // Set guestUUID cookie if not already set
  let guestUUID = Cookies.get("exp_guest_uuid");

  if (!guestUUID) {
    guestUUID = uuidv4();
    Cookies.set("exp_guest_uuid", guestUUID);
  }

  return new GrowthBook({
    apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
    clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
    enableDevMode: process.env.NODE_ENV === "development",
    attributes: {
      id: guestUUID,
    },
    features,
  });
}

function getGrowthBook() {
  if (!growthbookInstance) {
    growthbookInstance = initGrowthbook();
    return growthbookInstance;
  }
  return growthbookInstance;
}

export { features, initGrowthbook, getGrowthBook };
